// Calendario sanitario de referencia (ganadería UY). Las fechas exactas de las
// campañas obligatorias las fija el MGAP cada año; acá se usan ventanas típicas
// para generar avisos en la Agenda. El productor puede ajustar/agendar la real.
export const CAMPANAS_SANITARIAS = [
  { id: "aftosa-otono",  nombre: "Vacunación aftosa — campaña de otoño",       tipo: "Vacuna",         mes: 3,  dia: 1,  oblig: true,  nota: "Fecha exacta la fija el MGAP" },
  { id: "aftosa-prim",   nombre: "Vacunación aftosa — campaña de primavera",   tipo: "Vacuna",         mes: 9,  dia: 1,  oblig: true,  nota: "Fecha exacta la fija el MGAP" },
  { id: "brucelosis",    nombre: "Brucelosis — terneras de 3 a 8 meses",        tipo: "Vacuna",         mes: 3,  dia: 15, oblig: true,  nota: "Según nacimientos" },
  { id: "carbunco",      nombre: "Vacunación carbunco (bacteridiano)",          tipo: "Vacuna",         mes: 9,  dia: 15, oblig: false, nota: "Zonas endémicas" },
  { id: "clostridial",   nombre: "Clostridiales (mancha/gangrena) pre-parición", tipo: "Vacuna",        mes: 7,  dia: 1,  oblig: false, nota: "Antes de la parición" },
  { id: "antiparasit",   nombre: "Antiparasitario / control de garrapata",      tipo: "Antiparasitario", mes: 10, dia: 1,  oblig: false, nota: "Según carga parasitaria" },
];

// Devuelve las campañas cuya próxima fecha cae dentro de `dias` días.
export function proximasCampanas(dias = 45, hoy = new Date()) {
  const base = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate(), 12);
  return CAMPANAS_SANITARIAS
    .map((c) => {
      let d = new Date(base.getFullYear(), c.mes - 1, c.dia, 12);
      if (d < base) d = new Date(base.getFullYear() + 1, c.mes - 1, c.dia, 12);
      const enDias = Math.round((d - base) / 86400000);
      return { ...c, fecha: d.toISOString().slice(0, 10), enDias };
    })
    .filter((c) => c.enDias >= 0 && c.enDias <= dias)
    .sort((a, b) => a.enDias - b.enDias);
}
